const n = (t, r, e) => new Date(t) < new Date(r) ? e ? 1 : -1 : e ? -1 : 1, u = (t, r, e) => t < r ? e ? -1 : 1 : t > r ? e ? 1 : -1 : 0, l = (t, r, e) => {
  const o = t || "", a = r || "";
  let s = o.toLowerCase().localeCompare(a.toLowerCase());
  return e || (s *= -1), s;
};
export {
  u as a,
  l as b,
  n as s
};
//# sourceMappingURL=sort.779f43d3.js.map
